"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianDustProcessingPlant = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var Units_1 = require("../../Units");
var MartianDustProcessingPlant = (function (_super) {
    __extends(MartianDustProcessingPlant, _super);
    function MartianDustProcessingPlant() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MARTIAN_DUST_PROCESSING_PLANT,
            cost: 15,
            tags: [Tags_1.Tags.MARS, Tags_1.Tags.BUILDING],
            productionBox: Units_1.Units.of({ energy: -1, steel: 2 }),
            tr: { tr: 1 },
            metadata: {
                cardNumber: 'Pf44',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.minus().energy(1).nbsp.steel(2); }).br;
                    b.tr(1);
                }),
                description: 'Decrease your energy production 1 step, and raise your steel production 2 steps. Gain 1 TR.',
                victoryPoints: 1,
            },
        }) || this;
    }
    MartianDustProcessingPlant.prototype.canPlay = function (player) {
        return player.canAdjustProduction(this.productionBox);
    };
    MartianDustProcessingPlant.prototype.play = function (player) {
        player.adjustProduction(this.productionBox);
        player.increaseTerraformRating();
        return undefined;
    };
    return MartianDustProcessingPlant;
}(Card_1.Card));
exports.MartianDustProcessingPlant = MartianDustProcessingPlant;
